import axios from 'axios'
import { map, cloneDeep } from 'lodash'
const url = process.env.VUE_APP_PRINTER_SERVICE_URL
    ? process.env.VUE_APP_PRINTER_SERVICE_URL + '/pos_sale'
    : 'https://localhost:5200/api/pos_sale'

const itemFormatter = items =>
    map(items, item => {
        console.log({ item })
        let price = item.sale_price
        if (item.discounted_price) price = item.discounted_price
        if (item.neto) {
            price = item.neto
        }
        if (item.replaced_price && item.replaced_price.replaced)
            price = item.sale_price
        let obj = {
            product_name: item.name,
            quantity: parseFloat(item.quantity),
            price,
            net_price: price || null,
            discount_percentage: item.lineDiscount
                ? item.lineDiscount.percentage_discount || 0
                : 0,
            discount_line_amount: item.lineDiscount
                ? item.lineDiscount.unit_price_discount || 0
                : 0,
            sub_total: parseInt(item.subtotal),
        }
        if (item.neto) delete obj.price
        else if (obj.price) delete obj.net_price
        return obj
    })

const cashDeskReceiptItemFormatter = items => {
    // console.log({ items })
    return map(items, item => ({
        product_name: item.wh_product ? item.wh_product.name || '' : '',
        quantity: parseFloat(item.quantity),
        price: parseInt(item.price),
        discount_percentage: parseInt(item.discount_or_charge_percentage),
        discount_line_amount:
            !parseInt(item.discount_or_charge_percentage) &&
            parseInt(item.discount_or_charge_value)
                ? parseInt(item.discount_or_charge_value)
                : 0,
        sub_total: parseInt(item.total || item.subtotal),
    }))
}

const cashDeskPaymentFormatter = payments =>
    map(payments, payment => {
        let obj = { amount: parseInt(payment.payment) }
        if (payment.paymentMethod === 1) {
            obj = Object.assign(obj, { method: 'EFECTIVO', description: '-' })
        } else if (payment.paymentMethod === 2) {
            obj = Object.assign(obj, {
                method: 'DÉBITO',
                description: payment.paymentDetail
                    ? `N°OPERACIÓN: ${payment.paymentDetail.voucher}`
                    : '',
            })
        } else if (payment.paymentMethod === 3) {
            obj = Object.assign(obj, {
                method: 'CRÉDITO',
                description: payment.paymentDetail
                    ? `N°OPERACIÓN: ${payment.paymentDetail.voucher}`
                    : '',
            })
        } else if (payment.paymentMethod === 6) {
            obj = Object.assign(obj, {
                method: 'TRANSFERENCIA BANCARIA',
                description: payment.paymentDetail
                    ? `N°TRANSFERENCIA: ${payment.paymentDetail.transNumber}`
                    : '',
            })
        } else if (payment.paymentMethod === 8) {
            obj = Object.assign(obj, {
                method: 'NOTA DE CRÉDITO',
                description: payment.paymentDetail
                    ? `N°${payment.paymentDetail.sl_sale_credit_note_id}`
                    : '',
            })
        }
        return obj
    })

const formatProducts = payload =>
    payload.items ? itemFormatter(payload.items) : '-'

const calcDiscountAsAmount = (percentage, total) => {
    try {
        return (
            Math.round((100 * total) / (100 - parseInt(percentage))) - total
        ).toLocaleString('es')
    } catch (e) {
        return null
    }
}

const formatBase = payload => ({
    company_name: payload.title,
    header_subtitle: payload.subtitle,
    sale_date_time: payload.dateTime
        ? payload.dateTime.date + ' ' + payload.dateTime.time
        : new Date(),
    sale_seller: payload.seller,
    sale_type: payload.saleType,
    sale_products: formatProducts(payload),
    discount_text:
        payload.globalDiscount && payload.globalDiscount.percentage_discount
            ? `Descuento global aplicado de ${parseInt(
                  payload.globalDiscount.percentage_discount
              )}%, equivalente a $${calcDiscountAsAmount(
                  payload.globalDiscount.percentage_discount,
                  payload.total
              )}`
            : payload.globalDiscount && payload.globalDiscount.amount_discount
            ? `Descuento global aplicado de $${parseInt(
                  payload.globalDiscount.amount_discount
              )}`
            : '',
    total_entrante: 0, // No sé que es, pero estaba en el front
    total: payload.total,
    footer_text: 'DOCUMENTO NO VÁLIDO COMO BOLETA',
    total_iva: parseInt(payload.iva || payload.total*0.19 || 0),
    total_neto: payload.neto || 0,
})

const addTopBarCode = payload => ({
    sale_code: payload.barcode,
})

const addCustomerData = payload => ({
    customer_rut: payload.cRUT,
    customer_business_name: payload.cbusinessName,
    customer_alias_name: payload.cpersonName,
    customer_commercial_business: payload.cactivities,
    customer_address: payload.caddress,
    customer_phone: '',
    cusotmer_email: '', //payload.cmail,
})

const addCompanyData = payload => ({
    header_rut: `RUT: ${payload.RUT}`,
    business_commercial_business: payload.activities,
    business_address: payload.address,
    business_phone: '',
})

const addQuotationData = payload => ({
    ...addCompanyData(payload),
    footer_barcode: payload.barcode,
    disclaimer_text: `COTIZACIÓN VALIDA HASTA EL ${payload.quotationExpiration}`,
})

const addDispatchRequestData = payload => ({
    ...addCompanyData(payload),
    header_rut: `RUT: ${payload.RUT}`,
    remark_quantities: true,
})

const addChangeData = payload => ({
    in_sale_product_message: 'ENTRANTE',
    in_sale_products: itemFormatter(payload.incomingDetail || []),
    detail_product_message: 'SALIENTE',
    total_entrante: payload.incomingTotal,
    total_saliente: payload.total,
    total: payload.total - payload.incomingTotal,
    discount_text: '',
})

const formatPayload = payload => {
    let obj = formatBase(payload)
    if (payload.typeCode === 3) {
        obj = { ...obj, ...addQuotationData(payload) }
    } else if (payload.typeCode === 2) {
        obj = { ...obj, ...addCustomerData(payload) }
    } else if (payload.typeCode === 6) {
        obj = Object.assign(obj, addChangeData(payload))
    } else if (payload.typeCode === 10) {
        obj = { ...obj, ...addDispatchRequestData(payload) }
    }
    if ([1, 2, 6].includes(payload.typeCode)) {
        obj = { ...obj, ...addTopBarCode(payload) }
    }
    // console.log({ obj })
    return obj
}

const formatCashDeskReceipt = payload => {
    let obj = cloneDeep(payload)
    delete obj.items
    delete obj.sale_payments
    obj.sale_products = cashDeskReceiptItemFormatter(payload.items)
    obj.sale_payments = cashDeskPaymentFormatter(payload.sale_payments)
    return obj
}

export default {
    formatPayload,
    formatCashDeskReceipt,
    print: payload => {
        return new Promise((resolve, reject) =>
            axios
                .post(url, formatPayload(payload))
                .then(resolve)
                .catch(reject)
        )
    },
    printRaw: payload => {
        return axios.post(url, payload)
    },
    printCashDeskReceipt: payload => {
        return new Promise((resolve, reject) =>
            axios
                .post(url, formatCashDeskReceipt(payload))
                .then(resolve)
                .catch(reject)
        )
    },
}
